<template>
    <div>
      <form @submit.prevent="submitPost">
        <input type="text" v-model="post.titulo" placeholder="Título" />
        <input type="text" v-model="post.autor" placeholder="Autor" />
        <textarea v-model="post.resumen" placeholder="Resumen"></textarea>
        <input type="text" v-model="post.palabras_claves" placeholder="Palabras Claves" />
        <input type="text" v-model="post.imagen" placeholder="URL de la Imagen" />
        <input type="text" v-model="post.avatar" placeholder="URL del Avatar" />
        <input type="checkbox" v-model="post.seguir" /> Seguir
        <div>
          <input type="text" v-model="post.formulario.pregunta" placeholder="Pregunta del Formulario" />
          <input type="number" v-model="post.formulario.respuesta" placeholder="Respuesta del Formulario" />
        </div>
        <!-- Campos adicionales para 'documento' -->
        <textarea v-model="post.documento.introduccion" placeholder="Introducción"></textarea>
        <!-- Agrega campos para las otras partes del documento según sea necesario -->
        <button type="submit">Crear Post</button>
      </form>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        post: {
          titulo: '',
          autor: [],
          resumen: '',
          palabras_claves: [],
          imagen: '',
          avatar: '',
          seguir: false,
          formulario: {
            pregunta: '',
            respuesta: 0
          },
          interacciones: {
            comentarios: 0,
            compartidos: 0,
            me_gustas: 0
          },
          documento: {
            agradecimiento: [],
            apendices: [],
            conclusion: '',
            discusion: '',
            introduccion: '',
            metodologia: '',
            referencias: [],
            resultados: ''
          }
        }
      };
    },
    methods: {
      submitPost() {
        axios.post('URL_DE_TU_API', this.post)
          .then(response => {
            // Manejo de la respuesta
            console.log(response);
          })
          .catch(error => {
            // Manejo de errores
            console.error(error);
          });
      }
    }
  };
  </script>
  